import { render } from "./AutoReload.vue?vue&type=template&id=38ab2bfc&scoped=true"
import script from "./AutoReload.vue?vue&type=script&lang=js"
export * from "./AutoReload.vue?vue&type=script&lang=js"

import "./AutoReload.vue?vue&type=style&index=0&id=38ab2bfc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38ab2bfc"]])

export default __exports__